import * as fromActions from '../Actions/Actions';
import { ActionTypes } from '../Actions/Actions';
import { IGameState } from '../Store/store';
import { getLevelIndex } from './level';
import { BOOSTER_LIST, ItemIDs, itemUnlockInfo } from '../../Config/Items';

export type BoosterId = ItemIDs;

export interface IStateBoosters {
    availableBoosters: BoosterId[];
    currentBoosters: BoosterId[];
    waitingBoosters: BoosterId[];
    activeBoosters: BoosterId[];
    prelevel: BoosterId[];
    active: boolean;
    lockedBoosters: BoosterId[];
    freeBoosters: BoosterId[];
    friendsBoosters: BoosterId[];
    matchCounter: number;

    [key: string]: BoosterId[] | boolean | number;
}

export const defaultBoosters: IStateBoosters = {
    active: true,
    availableBoosters: [ItemIDs.SHUFFLE, ItemIDs.SHUFFLE, ItemIDs.SHUFFLE],
    currentBoosters: [],
    waitingBoosters: [],
    activeBoosters: [],
    prelevel: [],
    lockedBoosters: [],
    freeBoosters: [],
    friendsBoosters: [],
    matchCounter: 0,
};

export const StateBoosters = (
    state = defaultBoosters,
    action: fromActions.Actions
): IStateBoosters => {
    switch (action.type) {
        case ActionTypes.START_LEVEL:
            return {
                ...state,
                active: true,
                currentBoosters: [],
                lockedBoosters: getLocked(getLevelIndex(action.payload)),
                freeBoosters: getFree(getLevelIndex(action.payload)),
            };
        case ActionTypes.ACTIVATE_BOOSTER:
            const w = state.waitingBoosters
                .slice(0)
                .filter(waiter => !action.payload.includes(waiter));
            const active = [...state.activeBoosters, action.payload];
            return {
                ...state,
                activeBoosters: active,
                waitingBoosters: w,
            };
        case ActionTypes.ADD_FRIEND_BOOSTER:
            return {
                ...state,
                friendsBoosters: [...state.friendsBoosters, action.payload],
            };
        case ActionTypes.ADD_FREE_BOOSTER:
            const free = [...state.freeBoosters];
            if (!free.includes(action.payload)) {
                free.push(action.payload);
            }
            return {
                ...state,
                freeBoosters: free,
            };
        case ActionTypes.ADD_GAME_BOOSTER:
            let b = state.currentBoosters.slice(0);
            const avail = state.availableBoosters.slice(0);
            b = [...b, ...action.payload];
            if (avail.includes(action.payload[0])) {
                avail.splice(avail.indexOf(action.payload[0]), 1);
            }

            return {
                ...state,
                currentBoosters: b,
                availableBoosters: avail,
                matchCounter: action.payload[0] === ItemIDs.HIGHLIGHT ? 0 : state.matchCounter,
            };
        case ActionTypes.INCREMENT_BOOSTER_MATCH:
            return {
                ...state,
                matchCounter: state.matchCounter + 1,
            };
        case ActionTypes.CANCEL_BOOSTER:
            const waiting = state.waitingBoosters
                .slice(0)
                .filter(waiter => waiter !== action.payload);
            const current = state.currentBoosters.slice(0).filter(cur => cur !== action.payload);
            return {
                ...state,
                waitingBoosters: waiting,
                currentBoosters: current,
            };
        case ActionTypes.REMOVE_FRIEND_BOOSTER:
            const friendsBoosters = state.friendsBoosters.slice(0);
            const index = friendsBoosters.indexOf(action.payload);
            if (index >= 0) {
                friendsBoosters.splice(index, 1);
            }
            return {
                ...state,
                friendsBoosters,
            };
        case ActionTypes.REMOVE_GAME_BOOSTER:
            let r = state.currentBoosters.slice(0);
            r = r.filter(rs => action.payload.indexOf(rs) === -1);
            let r2 = state.activeBoosters.slice(0);
            r2 = r2.filter(rs => action.payload.indexOf(rs) === -1);
            let w2 = state.waitingBoosters.slice(0);
            w2 = w2.filter(ws => action.payload.indexOf(ws) === -1);
            return {
                ...state,
                currentBoosters: r,
                activeBoosters: r2,
                waitingBoosters: w2,
            };
        case ActionTypes.SHOW_BOOSTER:
            return {
                ...state,
                waitingBoosters: [...state.waitingBoosters, action.payload],
            };
        case ActionTypes.SILENT_STORE_BOOSTER:
            let av2 = state.availableBoosters.slice(0);
            av2 = [...av2, ...action.payload];
            return {
                ...state,
                availableBoosters: av2,
            };

        case ActionTypes.STORE_GAME_BOOSTER:
            let av = state.availableBoosters.slice(0);
            av = [...av, ...action.payload];
            return {
                ...state,
                availableBoosters: av,
            };
        case ActionTypes.REMOVE_STORED_BOOSTER:
            const ab = state.availableBoosters.slice(0);
            ab.splice(ab.indexOf(action.payload), 1);
            return {
                ...state,
                availableBoosters: ab,
            };
        case ActionTypes.UNLOCK_BOOSTER:
            const locked = state.lockedBoosters.filter(b => b !== action.payload);
            return {
                ...state,
                lockedBoosters: locked,
            };
        default:
            return state;
    }
};

export const getBoosterActive = (state: IGameState) => {
    return (
        // !state.StatePause.paused &&
        !state.StateLevel.complete &&
        // !state.StateLevel.stuck &&
        !state.StateLevel.shuffling
    );
};

export const getBoosterAvailable = (state: IStateBoosters, id: ItemIDs) => {
    return state.availableBoosters.includes(id);
};

export const getBoosterPlaying = (state: IStateBoosters, id: ItemIDs) => {
    return state.currentBoosters.includes(id);
};

const getLocked = (index: number) => {
    const fullList = [...BOOSTER_LIST];
    if (!fullList.includes(ItemIDs.TIME)) {
        fullList.push(ItemIDs.TIME);
    }
    return fullList.reduce((arr, item) => {
        if (itemUnlockInfo.find(x => x.id === item).unlockLevel > index) {
            arr.push(item);
        }
        return arr;
    }, []);
};

const getFree = (index: number) => {
    const fullList = [...BOOSTER_LIST];
    if (!fullList.includes(ItemIDs.TIME)) {
        fullList.push(ItemIDs.TIME);
    }
    return fullList.reduce((arr, item) => {
        if (itemUnlockInfo.find(x => x.id === item).unlockLevel === index) {
            if (item !== ItemIDs.TIME) {
                // time booster is added to free during level
                arr.push(item);
            }
        }
        return arr;
    }, []);
};
